import { useCallback } from "react";
import useSWRMutation from "swr/mutation";
import { useApi } from "./api";
import { CustomError } from "./errors";
import { SearchPermissionsResponse } from "./types/permissions";

export const usePermissionsApi = () => {
  const api = useApi();

  // Every permission, also the ones no role grants.
  const getAdminPermissions = useCallback(() => {
    const url = "/admin/permissions";
    return useSWRMutation<SearchPermissionsResponse, CustomError, string>(url, (url) =>
      api.get<SearchPermissionsResponse>({ url }),
    );
  }, [api]);

  return { getAdminPermissions };
};
